function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { Text } from "@dhxete/text";
import DataItem from "./DataItem/DataItem";
const textStyle = {
  fontSize: "14px",
  color: "#222"
};
const TopDivStyle = styled.div`
  box-sizing: border-box;
  padding: 15px 10px 5px;
`;
const BottomDivStyle = styled.div`
  box-sizing: border-box;
  padding: 5px 10px 15px;
`;
const NoFoundDivStyle = styled.div`
  box-sizing: border-box;
  padding: 15px 10px;
`;
const RelativeDivStyle = styled.div`
  position: relative;
`; // For PV, GAC, HULA

const DataList = ({
  langStrings,
  dispatch,
  className,
  datalist,
  serialNumberAndProductName
}) => {
  const handleSelect = item => {
    dispatch({
      type: "ENTER_SERIAL_NUMBER",
      payload: item
    });
    dispatch({
      type: "SHOW_SELECT_YOUR_VERSION"
    });
  };

  return /*#__PURE__*/React.createElement(RelativeDivStyle, null, /*#__PURE__*/React.createElement("div", {
    className: className
  }, datalist.length ?
  /*#__PURE__*/
  // If nothing found, show different message
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopDivStyle, null, /*#__PURE__*/React.createElement(Text, _extends({
    fontWeight: "bold"
  }, textStyle), langStrings.processInfoScreen.serialNumbersInAccount)), datalist.map((item, i) => {
    const [serialNumber, productName] = item.split("     ");
    return /*#__PURE__*/React.createElement(DataItem, {
      key: i,
      serialNumber: serialNumber,
      productName: productName,
      handleSelect: () => handleSelect(item),
      serialNumberAndProductName: serialNumberAndProductName
    });
  }), /*#__PURE__*/React.createElement(BottomDivStyle, null, /*#__PURE__*/React.createElement(Text, textStyle, langStrings.processInfoScreen.justTypeIn))) : /*#__PURE__*/React.createElement(NoFoundDivStyle, null, /*#__PURE__*/React.createElement(Text, {
    fontStyle: "italic"
  }, langStrings.processInfoScreen.noResultsMsg))));
};

DataList.propTypes = {
  langStrings: PropTypes.object,
  dispatch: PropTypes.func,
  className: PropTypes.string,
  datalist: PropTypes.array,
  serialNumberAndProductName: PropTypes.string
};
export default styled(DataList)`
  box-sizing: border-box;
  position: absolute;
  top: -10px;
  width: 100%;
  max-height: 170px;
  overflow-y: auto;
  background-color: #fff;
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
  z-index: 100;
  ${props => props.datalist.length || css`
      background-color: #f7f7f7;
    `}
`;